import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWaveVoter } from "@/generated/models/ApiWaveVoter";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface WaveLeaderboardRightSidebarVoterProps {
  readonly voter: ApiWaveVoter;
  readonly position: number;
  readonly creditType: ApiWaveCreditType;
}
export const WaveLeaderboardRightSidebarVoter: React.FC<WaveLeaderboardRightSidebarVoterProps> = t0 => {
  const $ = _c(52);
  const {
    voter,
    position,
    creditType
  } = t0;
  const hasPositiveVotes = !!voter.positive_votes_summed;
  const hasNegativeVotes = !!voter.negative_votes_summed;
  let t1;
  if ($[0] !== position) {
    t1 = <span className="tw-text-iron-400 tw-font-medium tw-flex-shrink-0">{position}.</span>;
    $[0] = position;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/${voter.voter.handle}`;
  let t3;
  if ($[2] !== voter.voter.pfp) {
    t3 = voter.voter.pfp ? <img src={voter.voter.pfp} alt="" className="tw-size-5 tw-rounded-md tw-ring-1 tw-ring-inset tw-ring-white/10 tw-bg-iron-800 tw-flex-shrink-0 tw-object-contain" /> : <div className="tw-size-5 tw-rounded-md tw-ring-1 tw-ring-inset tw-ring-white/10 tw-bg-iron-800 tw-flex-shrink-0" />;
    $[2] = voter.voter.pfp;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = voter.voter.handle ?? voter.voter.id;
  let t5;
  if ($[4] !== voter.voter.handle) {
    t5 = <span className="tw-text-sm tw-font-medium tw-text-iron-200 tw-transition-all tw-duration-300 desktop-hover:group-hover:tw-text-opacity-80 tw-truncate">{voter.voter.handle}</span>;
    $[4] = voter.voter.handle;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <UserProfileTooltipWrapper user={t4}>{t5}</UserProfileTooltipWrapper>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t6) {
    t7 = <Link href={t2} className="tw-flex tw-items-center tw-gap-2 tw-no-underline desktop-hover:hover:tw-underline tw-group desktop-hover:hover:tw-opacity-80 tw-transition-all tw-duration-300 tw-max-w-full tw-min-w-0">{t3}{t6}</Link>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-3">{t1}{t7}</div>;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = `voter-votes-${voter.voter.handle}-${position}`;
  let t10;
  if ($[16] !== hasPositiveVotes) {
    t10 = hasPositiveVotes && <div className="tw-w-1.5 tw-h-1.5 tw-rounded-sm tw-bg-green" />;
    $[16] = hasPositiveVotes;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== hasNegativeVotes) {
    t11 = hasNegativeVotes && <div className="tw-w-1.5 tw-h-1.5 tw-rounded-sm tw-bg-red" />;
    $[18] = hasNegativeVotes;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t9) {
    t12 = <div className="tw-flex tw-items-center tw-gap-1" data-tooltip-id={t9}>{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = `voter-votes-${voter.voter.handle}-${position}`;
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== voter.positive_votes_summed) {
    t15 = formatNumberWithCommas(voter.positive_votes_summed);
    $[25] = voter.positive_votes_summed;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <div className="tw-text-green">+{t15}</div>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== hasNegativeVotes || $[30] !== voter.negative_votes_summed) {
    t17 = hasNegativeVotes && <div className="tw-text-red">-{formatNumberWithCommas(voter.negative_votes_summed)}</div>;
    $[29] = hasNegativeVotes;
    $[30] = voter.negative_votes_summed;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t16 || $[33] !== t17) {
    t18 = <div className="tw-text-sm tw-space-x-1">{t16}{t17}</div>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t13 || $[36] !== t18) {
    t19 = <Tooltip id={t13} style={t14}>{t18}</Tooltip>;
    $[35] = t13;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t12 || $[39] !== t19) {
    t20 = <>{t12}{t19}</>;
    $[38] = t12;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== voter.absolute_votes_summed) {
    t21 = formatNumberWithCommas(voter.absolute_votes_summed);
    $[41] = voter.absolute_votes_summed;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== creditType || $[44] !== t21) {
    t22 = <span className="tw-text-xs tw-text-iron-400 tw-whitespace-nowrap">{t21} {creditType}{" "}total</span>;
    $[43] = creditType;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t20 || $[47] !== t22) {
    t23 = <div className="tw-flex tw-items-center tw-gap-x-3 tw-ml-6">{t20}{t22}</div>;
    $[46] = t20;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t23 || $[50] !== t8) {
    t24 = <div className="tw-flex tw-flex-col tw-justify-between tw-gap-x-2 tw-gap-y-2 tw-w-full tw-p-3 tw-rounded-lg tw-bg-iron-900 tw-overflow-hidden">{t8}{t23}</div>;
    $[49] = t23;
    $[50] = t8;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  return t24;
};